import createIcon from '../../createIcon';

/**
 * @component @name PhotoFilter
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTkgMTBWMTlINC45OFY1SDEzLjk4VjNINUMzLjkgMyAzIDMuOSAzIDVWMTlDMyAyMC4xIDMuOSAyMSA1IDIxSDE5QzIwLjEgMjEgMjEgMjAuMSAyMSAxOVYxMEgxOVpNMTYuOTggMTBMMTcuOTIgNy45NEwxOS45OCA3TDE3LjkyIDYuMDZMMTYuOTggNEwxNi4wNCA2LjA2TDEzLjk4IDdMMTYuMDQgNy45NEwxNi45OCAxMFpNMTMuMjMgMTAuNzVMMTEuOTggOEwxMC43MyAxMC43NUw3Ljk4IDEyTDEwLjczIDEzLjI1TDExLjk4IDE2TDEzLjIzIDEzLjI1TDE1Ljk4IDEyTDEzLjIzIDEwLjc1WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const PhotoFilter = createIcon('PhotoFilter', [
  [
    'path',
    {
      d: 'M19 10V19H4.98V5H13.98V3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V10H19ZM16.98 10L17.92 7.94L19.98 7L17.92 6.06L16.98 4L16.04 6.06L13.98 7L16.04 7.94L16.98 10ZM13.23 10.75L11.98 8L10.73 10.75L7.98 12L10.73 13.25L11.98 16L13.23 13.25L15.98 12L13.23 10.75Z',
      key: '2v846j',
    },
  ],
]);

export default PhotoFilter;
